import { http } from "@/lib/http";
import type { ListMyPaymentsParams, MySubscription, PagedPayments } from "../mocks/fixtures";

export async function getMySubscription(): Promise<MySubscription> {
  const { data } = await http.get<MySubscription>("/me/subscription");
  return data;
}

export async function listMyPayments(params?: ListMyPaymentsParams): Promise<PagedPayments> {
  const { data } = await http.get<PagedPayments>("/me/subscription/payments", { params });
  return data;
}
